<template>
    <div class="day_map">
        <div id="mapDiv"></div>
        <div id="city_style"></div>
        <input type="text" id="info" value/>
        <div id="addressMsg" style="font-size:14px"></div>
        <br/>
        <div id="detailedAddress" style="font-size:14px"></div>
    </div>
</template>

<script>
    export default {
        name: "EDayMap",
        props: ["data_info"],
        data() {
            return {
                map: "",
                zoom: 2
            };
        },
        created() {
        },
        mounted() {
            // 1.初始化天地图
            this.map = new T.Map("mapDiv");
            var lnglat = new T.LngLat(10, 36.89945);
            //设置显示地图的中心点和级别
            this.map.centerAndZoom(lnglat, this.zoom);

            // 2.添加控件
            var ctrl = new T.Control.MapType();

            this.map.addControl(ctrl);
            this.onLoad();

            //this.setOption();
        },
        watch: {
            data_info(val) {
                this.data_info = val;
                this.onLoad();
            }
        },
        methods: {
            onLoad() {
                // try {
                this.map.clearOverLays();
                //鼠标惯性拖拽

                this.map.disableDrag();
                this.$nextTick(() => {
                    this.map.enableDrag();
                });
                //禁止滚动
                this.map.disableScrollWheelZoom();
                //禁止鼠标双击放大地图
                this.map.disableDoubleClickZoom();

                // 3.创建右键菜单对象
                // var menu = new T.ContextMenu({ width: 140 });
                // var txtMenuItem = [
                //   {
                //     text: "放大",
                //     callback: function() {
                //       map.zoomIn();
                //     }
                //   },
                //   {
                //     text: "缩小",
                //     callback: function() {
                //       map.zoomOut();
                //     }
                //   },
                //   {
                //     text: "放置到最大级",
                //     callback: function() {
                //       map.setZoom(18);
                //     }
                //   },
                //   {
                //     text: "查看全球",
                //     callback: function() {
                //       map.setZoom(2);
                //     }
                //   },
                //   {
                //     text: "获得右键点击处坐标",
                //     isDisable: false,
                //     callback: function(lnglat) {
                //
                //     }
                //   }
                // ];
                // for (var i = 0; i < txtMenuItem.length; i++) {
                //   //添加菜单项
                //   var item = new T.MenuItem(
                //     txtMenuItem[i].text,
                //     txtMenuItem[i].callback
                //   );
                //   //item.disable();
                //   menu.addItem(item);
                //   if (i == 1 || i == 3) {
                //     //添加分割线
                //     menu.addSeparator();
                //   }
                // }
                // map.addContextMenu(menu);

                // 4.自定义提示框

                //  var data_info = [
                //             {
                //               long: "-95.581458",
                //               lat: "48.072805",
                //               name: "北美洲"
                //             },
                //             {
                //               long: "-52.996315", //-52.996315,-8.140649
                //               lat: "-8.140649",
                //               name: "南美洲"
                //             },
                //             {
                //               long: "25.191489", //23.191489,48.930303
                //               lat: "50.930303",
                //               name: "欧洲"
                //             },
                //             {
                //               long: "24.633025", //23.633025,9.334916
                //               lat: "12.534916",
                //               name: "非洲"
                //             },
                //             {
                //               long: "107.962169", //102.962169,47.254241
                //               lat: "54.854241",
                //               name: "亚洲"
                //             },
                //             {
                //               long: "140.492654", //140.492654,-18.164714
                //               lat: "-17.164714",
                //               name: "大洋洲"
                //             },

                //         ];
                // var sContent = "天安门坐落在中国北京市中心,故宫的南侧,与天安门广场隔长安街相望,是清朝皇城的大门...";
                // pLngLat = new T.LngLat(19, 36.89945);
                // map.centerAndZoom(pLngLat, zoom);
                // var infoWindow = new T.InfoWindow(sContent);
                // map.openInfoWindow(infoWindow, pLngLat); //开启信息窗口
                // document.getElementById("result").innerHTML = "信息窗口的内容是：<br />" + infoWindow.getContent()
                //创建图片对象
                var icon = new T.Icon({
                    iconUrl: "http://api.tianditu.gov.cn/img/map/markerA.png",
                    iconSize: new T.Point(19, 27),
                    iconAnchor: new T.Point(10, 25)
                });
                for (var i = 0; i < this.data_info.length; i++) {
                    var marker = new T.Marker(
                        new T.LngLat(this.data_info[i].long, this.data_info[i].lat),
                        {icon: icon}
                    ); // 创建标注
                    var content =
                        this.data_info[i].englishName + "：" + this.data_info[i].value;
                    
                    // 将标注添加到地图中
                    this.map.addOverLay(marker);
                    var label = new T.Label({
                        text: "<b>" + content + "</b>",
                        position: marker.getLngLat(),
                        offset: new T.Point(3, -30)
                    });
                    this.map.addOverLay(label);
                    //addClickHandler(content, marker);
                }

                function addClickHandler(content, marker) {
                    marker.addEventListener("mouseover", function (e) {
                        openInfo(content, e);
                    });
                    //openInfo(content, e)
                    // onClose();
                }

                //marker.openInfoWindow(markerInfoWin);
                function openInfo(content, e) {
                    var point = e.lnglat;
                    // 创建标注
                    marker = new T.Marker(point);
                    // 创建信息窗口对象
                    var markerInfoWin = new T.InfoWindow(content, {
                        offset: new T.Point(0, -30)
                    });
                    //开启信息窗口
                    this.map.openInfoWindow(markerInfoWin, point);
                }

                // 5. 单击获取坐标
                // var cp = new T.CoordinatePickup(map, { callback: getLngLat });
                // cp.addEvent();
                // var axiosX;
                // var axiosY;

                // function getLngLat(lnglat) {
                //   axiosX = lnglat.lng.toFixed(6);
                //   axiosY = lnglat.lat.toFixed(6);

                //   // document.getElementById("lnglatStr").value = lnglat.lng.toFixed(6) + "," + lnglat.lat.toFixed(6);
                //   // return lnglat.lng.toFixed(6) + "," + lnglat.lat.toFixed(6);
                // }

                // 6. 单击获取坐标
                //创建对象
                // geocode = new T.Geocoder();
                // var isMove = false,
                //   timer = null;
                // var left;
                // var top;
                // var tag = document.getElementById("city_style");
                // var cityName;
                // map.addEventListener("mousemove", function(e) {
                //   isMove = true;
                //   clearTimeout(timer);

                //   tag.innerHTML = "";
                //   tag.style.display = "none";

                //   timer = setTimeout(function() {
                //     isMove = false;

                //     left = e.containerPoint.x;
                //     top = e.containerPoint.y;

                //     var mapDiv = document.getElementById("mapDiv");
                //     var r = document.getElementById("mapDiv").offsetWidth;
                //     var t = document.getElementById("mapDiv").offsetHeight;
                //     left = r - left <= 150 ? left - 130 : left;
                //     top = t - top <= 80 ? top - 50 : top;

                //     tag.style.left = left + "px";
                //     tag.style.top = top + "px";

                //     // if (cityName != '全球' && cityName != undefined) {
                //     //     tag.style.display = "block";
                //     //     tag.innerHTML = cityName;
                //     // }
                //     geocode.getLocation(e.lnglat, searchResult);
                //   }, 500);
                // });

                // 实时显示地图坐标点
                // map.addEventListener("mousemove", MapMousemove);
                // function MapMousemove(e) {
                //   document.getElementById("info").value =
                //     e.lnglat.getLng().toFixed(6) + "," + e.lnglat.getLat().toFixed(6);
                // }

                // function searchResult(result) {
                //   cityName = "";
                //   if (result.getStatus() == 0) {
                //     document.getElementById("addressMsg").innerHTML =
                //       "<font style='font-weight:700'>详细地址：</font>" +
                //       (result.getAddress() == null ? "暂无数据" : result.getAddress());

                //     var addressComponent = result.getAddressComponent();

                //     var html =
                //       "<font style='font-weight:700'>详细信息如下：</font><br/>";
                //     html +=
                //       "<font style='font-weight:700'>国家：" +
                //       (result.addressComponent.nation == null
                //         ? "暂无数据"
                //         : result.addressComponent.nation) +
                //       "</font><br/>";
                //     html +=
                //       "<font style='font-weight:700'>地理坐标X：" +
                //       (axiosX == undefined || null ? "暂无数据" : axiosX) +
                //       "</font><font style='font-weight:700'> 地理坐标Y：" +
                //       (axiosY == undefined || null ? "暂无数据" : axiosY) +
                //       "</font><br/>";
                //     html +=
                //       "<font style='font-size:12px'>此点所在国家或城市或区县：" +
                //       (addressComponent.city == null
                //         ? "暂无数据"
                //         : addressComponent.city) +
                //       "</font><br/>";

                //     document.getElementById("detailedAddress").innerHTML = html;
                //     cityName =
                //       result.addressComponent.nation == undefined || null
                //         ? "暂无数据"
                //         : result.addressComponent.nation;

                //     if (cityName != "全球" && cityName != undefined) {
                //       tag.style.display = "block";
                //       tag.innerHTML = cityName;
                //     }
                //   } else {
                //     document.getElementById("addressMsg").innerHTML =
                //       "<font style='font-weight:700'>服务器返回状态：</font>" +
                //       result.getStatus();
                //     document.getElementById("detailedAddress").innerHTML =
                //       "<font style='font-weight:700'>服务器返回响应信息：</font>" +
                //       result.getMsg();
                //   }
                //}
                // } catch (err) {
                //   
                //   //console.log("天地图加载不成功，请稍候再试！");
                // }
            }
        }
    };
</script>

<style scoped>
    .tdt-control-copyright {
        display: none;
    }

    .day_map {
        position: relative;
        width: 98%;
        height: 800px;
        overflow: hidden;
        margin-bottom: 30px;
    }

    #mapDiv {
        position: absolute;
        width: 100%;
        height: 100%;
        margin-left: 10px;
    }

    #city_style {
        position: absolute;
        border: 1px solid #cccc;
        width: 120px;
        height: 40px;
        z-index: 500;
        letter-spacing: 1px;
        color: #fff;
        background: #0b59c7;
        text-align: center;
        line-height: 40px;
        display: none;
    }

    #mapDiv >>> .tdt-label.tdt-clickable {
        background: rgba(0, 0, 0, 0.5) !important;
        color: #fff !important;
    }
</style>